angular.module('unergie.main')
.controller('adminCommentsModalCtrl', ($scope, $uibModalInstance, AuthService, AdminComments, BoFeaturesService,
    ErrorCatcher, object, comments, prefixComment, SocketFactory) => {
    $scope.preventCommentEditing = BoFeaturesService.isFeatureOn('preventCommentEditing')
    $scope.close = () => $uibModalInstance.dismiss()

    SocketFactory.join(object, $scope)

    SocketFactory.register('message', () => $scope.refreshComments())

    $scope.object = object
    $scope.comments = comments
    $scope.newComment = _.isEmpty(prefixComment) ? '' : prefixComment

    $scope.isMyComment = (comment) => AuthService.getAuth().uuid === comment.commenter.uuid

    $scope.refreshComments = () => {
        AdminComments.getComments({ object: $scope.object }).$promise.then((newComments) =>
            _.forEach(newComments, (c) => {
                const previous = _.find($scope.comments, { _id: c._id })
                if (!previous) {
                    $scope.comments.push(c)
                } else if ((previous.comment !== c.comment) && !previous.editing) {
                    previous.comment = c.comment
                }
            })).catch(ErrorCatcher)
    }

    $scope.refreshComments()

    $scope.cancelEditing = (comment) => {
        comment.editing = false
        $scope.refreshComments()
    }

    $scope.addComment = () => {
        AdminComments.addComment({ object: $scope.object, comment: $scope.newComment }).$promise.then(() => {
            $scope.refreshComments()
            $scope.newComment = ''
        }).catch(ErrorCatcher)
    }


    $scope.removeComment = (comment) => {
        AdminComments.deleteComment({ id: comment._id }).$promise.then(() => {
            $scope.refreshComments()
        }).catch(ErrorCatcher)
    }


    $scope.saveComment = (comment) => {
        AdminComments.updateComment({ id: comment._id }, { comment: comment.comment }).$promise.then(() => {
            $scope.refreshComments()
            comment.editing = false
        }).catch(ErrorCatcher)
    }

    const saveOrUpdate = (comment) => {
        if (comment) {
            $scope.saveComment(comment)
        } else {
            $scope.addComment()
        }
    }

    $scope.kbconfig = (comment) => ([
        { combo: [17, 13], func: saveOrUpdate, data: comment },
    ])

    $scope.canModify = (comment) => !$scope.preventCommentEditing && comment.comment.indexOf('<b>AUTOMATIQUE</b>') !== 0
})
